import script from "./CourseManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseManager.vue?vue&type=script&setup=true&lang=js"

import "./CourseManager.vue?vue&type=style&index=0&id=43d8e685&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d8e685"]])

export default __exports__